export default [
  {
    title: 'Casa extraordinaria, amplia y con todo en regla',
    imageUrl: 'http://www.construyehogar.com/wp-content/uploads/2015/06/Dise%C3%B1o-de-casa-moderna-de-dos-plantas.jpg',
    operationType: 'sell',
    price: 3000000,
    currency: 'MXN',
    address: 'Lago Zúrich 243 en Colonia Ampliación Granada C.P. 11529, Durango',
    state: 'Durango',
    amenities: {
      bedrooms: 3,
      bathrooms: 2,
      parkingSpaces: 1,
      area: 45
    }
  },
  {
    title: 'Hermosa casa',
    imageUrl: 'https://i.pinimg.com/736x/73/de/32/73de32f9e5a0db66ec7805bb7cb3f807--navy-blue-houses-blue-and-white-houses-exterior.jpg',
    operationType: 'rent',
    price: 45000,
    currency: 'MXN',
    address: 'Lago Zúrich 243 en Colonia Ampliación Granada C.P. 11529, Durango',
    state: 'S. Luis Potosí',
    amenities: {
      bedrooms: 5,
      bathrooms: 3,
      parkingSpaces: 2,
      area: 111
    }
  },
  {
    title: 'Hermosa casa con acabados de maderas del oriente',
    imageUrl: 'https://cdn.houseplans.com/product/o2d2ui14afb1sov3cnslpummre/w560x373.jpg',
    operationType: 'venta',
    price: 2300000,
    currency: 'MXN',
    address: 'Lago Zúrich 243 en Colonia Ampliación Granada C.P. 11529, Durango',
    state: 'CDMX',
    amenities: {
      bedrooms: 5,
      bathrooms: 3,
      parkingSpaces: 2,
      area: 111
    }
  },
  {
    title: 'Casa antigua amueblada',
    imageUrl: 'http://www.jamiehousephotography.co.uk/wp-content/uploads/2016/08/90771eabbe519de766c8ce23fb3a15fc.jpg',
    operationType: 'rent',
    price: 19000,
    currency: 'MXN',
    address: 'Lago Zúrich 243 en Colonia Ampliación Granada C.P. 11529, Durango',
    state: 'Saltillo',
    amenities: {
      bedrooms: 3,
      bathrooms: 2,
      parkingSpaces: 1,
      area: 97
    }
  },
  {
    title: 'Departamento de categoría',
    imageUrl: 'https://www.adinahotels.com/wp-content/uploads/sites/4/2016/07/adina-melbourne-flinders-street-apartment-hotel-one-and-two-bedroom-apartment-2-2013.jpg',
    operationType: 'sell',
    price: 2750000,
    currency: 'MXN',
    address: 'Lago Zúrich 243 en Colonia Ampliación Granada C.P. 11529, Durango',
    state: 'CDMX',
    amenities: {
      bedrooms: 2,
      bathrooms: 1,
      parkingSpaces: 1,
      area: 80
    }
  }
]